// The native launch URL can arrive after a password reset has completed. Do not
// reopen a form whose single-use token has already been redeemed in this app run.
const completedResetTokens = new Set<string>();

export function markResetTokenCompleted(token: string): void {
  completedResetTokens.add(token);
}

/** Translate an incoming app link into a HashRouter route. */
export function getDeepLinkTarget(url: string): string | null {
  try {
    const parsed = new URL(url);
    const resetToken = parsed.searchParams.get("resetToken");
    if (resetToken) {
      if (completedResetTokens.has(resetToken)) return null;
      return `/login/password-reset?resetToken=${encodeURIComponent(
        resetToken
      )}`;
    }
    const target = parsed.hash
      ? parsed.hash.replace(/^#/, "")
      : parsed.pathname;
    return target && target !== "/" ? target : null;
  } catch {
    return null;
  }
}
